import React from "react";

const About = () => {
  return (
    <div style={{ height: "100vh" }}>
      <h2 className="text-center my-5">About Us</h2>
    </div>
  );
};

export default About;
